import { useEffect, useState } from "react";
import { Lightbulb } from "lucide-react";
import { BRAND_COLORS } from "@/lib/menuData";

const FACTS = [
  // Pizza
  { emoji: "🍕", text: "Hunt Brothers Pizza is baked fresh in-store, never frozen — the first pizza is $11.99, the next just $10." },
  { emoji: "🧀", text: "Extra Cheese is our #1 add-on — over 40% of pizzas leaving the counter get an extra layer." },
  { emoji: "🌶️", text: "Craving a kick? Try Jalapeños on Half & Half so everyone at the table is happy." },
  { emoji: "🍕", text: "Fun fact: Pineapple on pizza was invented in Canada in 1962 — our Hawaiian is a crowd favorite." },
  { emoji: "🔥", text: "Our thin crust cooks two minutes faster than the regular — perfect for the impatient." },

  // Chicken
  { emoji: "🍗", text: "Krispy Krunchy Chicken has been serving Cajun-inspired chicken since 1989." },
  { emoji: "🎉", text: "Our biscuits are made fresh every morning — first come, first served." },
  { emoji: "🥣", text: "Try our tenders with the honey mustard dipping sauce — chef's pick." },
  { emoji: "🌶️", text: "Buffalo wings pair perfectly with ranch, but we won't judge if you go blue cheese." },

  // Menu / general
  { emoji: "🍔", text: "Every quarter-pound burger uses fresh ground beef — never a pre-formed patty." },
  { emoji: "🥤", text: "Grab a 24oz fountain drink with any combo meal — free refills at the counter." },
  { emoji: "🥗", text: "Ask us for a lighter option: our grilled chicken salad has protein without the deep fry." },
  { emoji: "🏝️", text: "We're an island local — 100% independently owned by folks who actually live on Dauphin Island." },
  { emoji: "📞", text: "Order not right? Use the Chat with Store button — a human is on the other side in seconds." },
  { emoji: "💰", text: "Loyalty tip: Buy 6 pizzas in a calendar month and the 7th is on us." },
  { emoji: "🕐", text: "We open at 5:30 AM most days — because early risers deserve hot biscuits too." },
];

/**
 * FunFactsCarousel — small info card rotating trivia every `intervalMs` (default 6s).
 * Compact by design so it fits inside the OrderStatus card or the CartDrawer waiting screen.
 */
export default function FunFactsCarousel({ intervalMs = 6000 }) {
  const [idx, setIdx] = useState(() => Math.floor(Math.random() * FACTS.length));

  useEffect(() => {
    const id = setInterval(() => {
      setIdx((n) => (n + 1) % FACTS.length);
    }, intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  const fact = FACTS[idx];

  return (
    <div
      data-testid="fun-facts-carousel"
      className="w-full rounded-2xl px-4 py-3 border transition-all duration-500"
      style={{
        backgroundColor: BRAND_COLORS.tropicalAqua + "12",
        borderColor: BRAND_COLORS.tropicalAqua + "44",
      }}
    >
      <div className="flex items-center gap-2 mb-1.5">
        <Lightbulb className="h-3.5 w-3.5" style={{ color: BRAND_COLORS.deepTeal }} />
        <span
          className="text-[10px] font-bold uppercase tracking-wider"
          style={{ color: BRAND_COLORS.deepTeal }}
        >
          Did you know?
        </span>
      </div>
      <p
        key={idx}
        data-testid="fun-fact-text"
        className="text-sm leading-snug animate-fade-in text-left"
        style={{ color: BRAND_COLORS.darkSlate }}
      >
        <span className="mr-1">{fact.emoji}</span>
        {fact.text}
      </p>
    </div>
  );
}
